import { render, staticRenderFns } from "./IconHeadphone.vue?vue&type=template&id=35b227f6&"
import script from "./IconHeadphone.vue?vue&type=script&lang=js&"
export * from "./IconHeadphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports